import { styled } from '../../Utilities';
import { SearchBoxBase } from './SearchBox.base';
import { getStyles } from './SearchBox.styles';
export var SearchBox = styled(SearchBoxBase, getStyles, undefined, { scope: 'SearchBox' });
//# sourceMappingURL=SearchBox.js.map